import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, School, Rocket, Heart, Share2, TrendingUp } from 'lucide-react';
const services = [{
  icon: BookOpen,
  title: 'Curriculum-Aligned Content Creation',
  description: 'Blog posts, worksheets, videos, and interactive materials that align with educational standards.',
  color: 'bg-gradient-to-br from-purple-400 to-purple-600'
}, {
  icon: School,
  title: 'School Outreach Campaigns',
  description: 'Direct engagement strategies to connect with educators, administrators, and decision-makers.',
  color: 'bg-gradient-to-br from-blue-400 to-blue-600'
}, {
  icon: Rocket,
  title: 'EdTech Product Launch Support',
  description: 'End-to-end launch strategies that get your educational product in front of the right audience.',
  color: 'bg-gradient-to-br from-pink-400 to-pink-600'
}, {
  icon: Heart,
  title: 'Parent & Community Engagement',
  description: 'Programs designed to build trust and involvement with parents and local communities.',
  color: 'bg-gradient-to-br from-red-400 to-red-600'
}, {
  icon: Share2,
  title: 'Social Media for Education Brands',
  description: 'Engaging social content that builds your brand and connects with your educational community.',
  color: 'bg-gradient-to-br from-green-400 to-green-600'
}, {
  icon: TrendingUp,
  title: 'SEO & Content Strategy',
  description: 'Data-driven strategies to increase visibility and drive organic traffic to your educational content.',
  color: 'bg-gradient-to-br from-yellow-400 to-yellow-600'
}];
export function Services() {
  return <section id="services" className="py-20 px-4 bg-gradient-to-br from-purple-50 to-pink-50" data-id="element-183">
      <div className="max-w-7xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-185">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-186">
            How Goblincamp Brings the Magic ✨
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-187">
            Comprehensive solutions to elevate your educational brand and reach
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-188">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="bg-white rounded-3xl overflow-hidden shadow-xl" data-id="element-189">
              <div className={`${service.color} p-6 flex justify-center items-center h-32`} data-id="element-190">
                <service.icon size={48} className="text-white" data-id="element-191" />
              </div>
              <div className="p-6" data-id="element-192">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-193">
                  {service.title}
                </h3>
                <p className="text-gray-600" data-id="element-194">{service.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}